import { CustomPage, CustomPagesState, PublicSiteCustomRoutes } from './types.mod'
import {
  mkWidget,
  Action,
  route,
  loadingAsyncState,
  async,
  Fun
} from 'widgets-for-react'
import { List } from "immutable"
import React = require('react')
import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteState, defaultLanguage } from '../../../public_site.main.mod'
import { getDrupalLanguage, getPage, PublicSite_CustomPageData } from '../application.mod'
import { GetDrupalBlockImagesLoaders } from '../../drupal/rendering/image_utils.mod'
import { DrupalBlock_To_WidgetBlock, parseMediaUrl } from '../../drupal/drupal_to_cms.mod'
import { loader } from '../templates/loader.mod'
import { notfound_page } from '../templates/error_page.mod'
import { t } from 'i18next'
import * as i18next from 'i18next'
import { GetOverview } from '../../drupal/api/api.mod'
import { PaginatedItem, PageTeaser } from '../../drupal/types_and_parser/extra_types.mod'
import { Link } from 'react-router-dom'
import { linkGridBlockClasses } from '../blocks/style.mod'
import { getClassName } from '../../cms/blocks/utils.gen'
import moment = require('moment')
import { Pagination } from '../templates/pagination.mod'
import { ParsedNodeStory } from '../../drupal/types_and_parser/types'
import { LinkGridBlockStyle } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { getLangFromUrl, removeLangFromUrl, updateUrlLang } from '../utils/history.mod'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../drupal/rendering/inview_utils.mod'
import { Page } from '../../cms/page/types.gen'
import { Block, isNonNullChain } from 'typescript'
import { CustomBlock } from '../../drupal/types_and_parser/custom_blocks.mod'
import { page_header } from '../templates/drupal_page_header.mod'

export const story_overview: CustomPage<CustomPagesState['story_overview']> = {
  widget: (r) =>
    mkWidget({
      run: (setState: (_: Action<CustomPagesState['story_overview']>) => void) => {
        const pageName = r.fst.kind == 'story_overview' ? r.fst.slug : ''
        let ss = r.snd
        const lang: string = r.fst.kind == 'story_overview' ? r.fst.lang : defaultLanguage

        const setPage = (page: number) => {
          window.history.pushState({}, '', `/${lang}/${pageName}/${page}`)
          setState((s) => ({
            ...s,
            overview_page: page,
            get_stories: loadingAsyncState(() => GetOverview<ParsedNodeStory>('stories-overview', lang, page))
          }))
        }

        const newsList =
          ss.get_stories.kind == 'loaded'
            ? ss.get_stories.value
            : ss.get_stories.kind == 'failed'
              ? ({} as PaginatedItem<ParsedNodeStory>)
              : null

        r.snd = ss

        const props = {
          StandardBlockImagesLoader: GetDrupalBlockImagesLoaders,
          StandardBlock_To_Widget: DrupalBlock_To_WidgetBlock,
          errorPage: notfound_page,
          loadingPage: loader
        }

        return (
          <>
            {async<Page<CustomBlock, Block, PublicSite_CustomPageData>>()(r.snd.storyPage as any).run((res) =>
              setState((previousState) => {
                const newState = res(r.snd.storyPage as any) as any
                // (property) storyPage: AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>>
                //             newState: AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>>

                return { ...previousState, storyPage: newState }
              })
            )}
            {async<PaginatedItem<ParsedNodeStory>>(null, {
              connectionError: mkWidget({
                run: (_) => {
                  return <div>Connection error.</div>
                }
              }),
              otherError: mkWidget({
                run: (_) => {
                  return <div>Error.</div>
                }
              }),
              loading: (_) =>
                mkWidget({
                  run: (_) => {
                    return <div></div>
                  }
                })
            })(ss.get_stories).run((res) =>
              setState((s) => {
                return { ...s, get_stories: res(s.get_stories) }
              })
            )}
            {r.snd.storyPage.kind == "loaded" && page_header([], [])(List())(r.snd.storyPage.value.extra_data.node).run((_) => null)}
            {ss.get_stories.kind == 'loaded'
              ? storyOverview(
                newsList,
                (filter) =>
                  setState((s1) => ({
                    ...s1,
                    get_stories: loadingAsyncState(() =>
                      GetOverview<ParsedNodeStory>('stories-overview', lang, ss.overview_page)
                    )
                  })),
                setPage,
                ss.overview_page,
                lang
              )
              : <div className="loader">
                <div className="loader__inner"></div>
              </div>}
          </>
        )
      }
    }),
  route: route<
    { slug: string; page: string; lang: string },
    CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>
  >('/:lang/:slug(stories)/:page(\\d+)?', (s) => ({
    kind: 'story_overview',
    slug: s.slug,
    page: s.page && parseInt(s.page),
    lang: s.lang
  })),
  getState: (s: PublicSiteState) => s.story_overview,
  setState: (s: PublicSiteState, ss: CustomPagesState['story_overview']) => {
    const s1 = { ...s, story_overview: ss }

    return s1
  },
  updateStateBasesOnRoute: (s, r) => {
    if (r.kind != 'story_overview') return s
    const page = isNaN(+r.page) ? 0 : +r.page

    return {
      ...s,
      story_overview: {
        overview_page: page,
        storyPage: getPage(removeLangFromUrl(window.location.pathname), []),
        get_stories: loadingAsyncState(() => GetOverview<ParsedNodeStory>('stories-overview', r.lang, page))
      }
    }
  }
}

const options: { style?: LinkGridBlockStyle } = {
  style: linkGridBlockClasses
}

const storyOverview = (
  page: PaginatedItem<ParsedNodeStory>,
  setNewsTypeFilter: Fun<string, void>,
  setPage: (page: number) => void,
  current_page: number,
  lang: string
) => {
  return (<>
    <main id="a11y-main" className="main main--stories-overview">
      <div className="main__inner">
        <article className="page">
          <div className="page__inner">
            <div className="page__content">
              <section className="block block--linkgrid block--variant-square" key={'news-overview'}>
                <div className={getClassName(options, 'inner_classname', 'py-5')}>
                  <div className={getClassName(options, 'content_classname', '')}>
                    {!page.items || page.items.count() == 0 ? (
                      <p>{t('Stories:no_results')}</p>
                    ) : (
                      <ul className={getClassName(options, 'list_classname', 'row list-unstyled mb-0')}>
                        {page.items.map((item: ParsedNodeStory) => {
                          return storyItem(item, lang)
                        })}
                      </ul>
                    )}
                    {page.pager && <Pagination pager={page.pager} setPage={setPage} />}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>
    </main>
  </>
  )
}

export const storyItem = (story_item: PageTeaser | ParsedNodeStory, lang: string) => {
  const isPageTeaser = (entity): entity is PageTeaser => (entity as PageTeaser).view_node !== undefined

  const link = isPageTeaser(story_item) ? story_item.view_node : story_item.language_links.get(getDrupalLanguage(getLangFromUrl()))
  const title = isPageTeaser(story_item) ? story_item.title : story_item.label
  let image = ''
  let alt = ''
  const creationDate: moment.Moment = isPageTeaser(story_item)
    ? moment(story_item.creation_date).locale(lang)
    : story_item.created

  if (isPageTeaser(story_item)) {
    image = story_item.field_introduction_image
  } else if (!isPageTeaser(story_item)) {
    if (story_item.field_introduction_image && story_item.field_introduction_image.thumbnail.image) {
      image = story_item.field_introduction_image.thumbnail.image.style_urls.grid
      alt = story_item.field_introduction_image.thumbnail.alt
    }
  }

  return (
    <li className="grid__item">
      <article className="grid__article">
        <Link to={updateUrlLang(link, getLangFromUrl())} className="grid__link">
          <div className="grid__content">
            <header className="grid__header">
              <time className="grid__label block__label label--m" dateTime={creationDate.format()}>
                {creationDate.locale(lang).format('D MMMM YYYY')}
              </time>
              <h3 className={getClassName(options, 'grid_title_classname', 'mb-2')}>{title}</h3>
            </header>
            <span className={getClassName(options, 'grid_fauxlink_classname', 'btn btn-link pl-0')}>
              {i18next.t('Stories:read_more')}
            </span>
          </div>
          <div className={`grid__visual container fit-object${image ? '' : ' grid__placeholder'}`}>
            {image && (
              <img src={parseMediaUrl(image)} alt={alt} className="grid__image lazyautosizes lazyloaded" />
            )}
          </div>
        </Link>
      </article>
    </li>
  )
}
